// What the Work Effort page tells the user when a save fails.
// api.js throws `API <status>: <body>`; the body of a refused save is FastAPI's
// {"detail": ...}, which is the server's own explanation (a field that can't be cleared,
// an unknown work effort id). The user gets those words, not the raw string.
// Pure (no React), so tests run it under node.

function serverDetail(err) {
  const text = String(err?.message || err || '')
  const m = text.match(/^API \d+: (.*)$/s)
  if (!m) return text
  let body
  try { body = JSON.parse(m[1]) } catch { return m[1] }
  const detail = body?.detail
  if (typeof detail === 'string') return detail
  if (Array.isArray(detail)) {
    // A request validation error: one entry per field, each naming where and what.
    return detail.map(d => {
      const where = Array.isArray(d?.loc) ? d.loc.filter(p => p !== 'body').join('.') : ''
      return where ? `${where}: ${d?.msg}` : String(d?.msg ?? JSON.stringify(d))
    }).join('; ')
  }
  return m[1]
}

export function saveErrorText(err) {
  const why = serverDetail(err).trim()
  return `Your last change was not saved${why ? `: ${why}` : '.'}`
}
